import { Text } from '@wework/dieter-ui'
import React from 'react'
import * as _ from 'lodash'
import noteIcon from '../../assets/icons/noteIcon.png'
import Row from '../Common/Row'
import IMTheme from '../../style/IMTheme'

const Note = ({
  space,
  noteModalHandler,
  bottomBorder,
  containerStyle = {},
}) => {
  if (!space) {
    return null
  }
  const { reservable } = space
  const note = _.get(reservable, 'note')
  const hasNote = note && note.trim() !== '0'

  return (
    <>
      <Row
        justify="flex-start"
        style={{ alignItems: 'start', ...containerStyle }}
      >
        <img
          src={noteIcon}
          style={{ width: 16, height: 16, marginRight: 2, marginTop: 4 }}
          alt={''}
        />
        <div>
          {hasNote && (
            <Text
              style={{
                fontWeight: IMTheme.fontWeights.normal,
                fontSize: IMTheme.fontSizes[2],
                marginLeft: IMTheme.spacing[4],
              }}
            >
              {note}
            </Text>
          )}
          <Text
            primary
            onClick={() => noteModalHandler(true)}
            style={{
              fontWeight: IMTheme.fontWeights.normal,
              fontSize: IMTheme.fontSizes[2],
              marginLeft: IMTheme.spacing[4],
              cursor: 'pointer',
            }}
          >
            {hasNote ? 'Update' : 'Add notes'}
          </Text>
        </div>
      </Row>
    </>
  )
}

export default Note
